// var megaMenuItems = document.querySelectorAll(".header__primary-nav-item .header__menu-disclosure");
// if(megaMenuItems.length){
//   megaMenuItems.forEach((megaMenu)=>{
//     var closeMenuBtn = megaMenu.querySelector(".menu-close-btn");
//     if(closeMenuBtn){
//       closeMenuBtn.addEventListener('click',function(){
//         console.log("clicked...");
//         megaMenu.setAttribute("aria-expanded","false");
//         megaMenu.removeAttribute('open');
        
//       });
//     }
//   });
// }
// function showActiveSecondLevelPanel() {
//   const activeButton = document.querySelector('.header-sidebar__main-panel li > button[aria-expanded="true"]');
//   if (!activeButton) return;

//   const panelId = activeButton.getAttribute('aria-controls');
//   const secondLevelPanel = document.querySelector('.header-sidebar__collapsible-panel.second-level');
//   const targetPanel = secondLevelPanel?.querySelector(`#${panelId}`);

//   if (targetPanel) {
//     targetPanel.removeAttribute('hidden');
//   }
// }


// document.querySelectorAll('.second-menu-btn').forEach(button => {
//     button.addEventListener('click', function () {
//       console.log("clicked.....");
//         // Close all other panels
//         document.querySelectorAll('.second-menu-btn').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
        
//         // Open the clicked panel
//         this.setAttribute('aria-expanded', 'true');
//         let targetId = this.getAttribute('aria-controls');
      
//         let parentPanel = this.closest('.header-sidebar__sub-panel');
//         console.log("parentPanel",parentPanel);
//         if (parentPanel) {
//             let nextDiv = parentPanel.nextElementSibling;
//             console.log("nextDiv",nextDiv);
//             if (nextDiv) {
//                 nextDiv.setAttribute('open', '');
//                 Object.assign(nextDiv.style, {
//                     display: 'block',
//                     opacity: '1',
//                     transform: 'translateX(0px)'
//                 });
               
//                 let targetDiv = nextDiv.querySelector(`#${targetId}`);

//                console.log('targetDiv',targetDiv);
//                 if (targetDiv) {
//                     targetDiv.removeAttribute('hidden');
//                 }
              
//             }
//         }
//     });
// });

// // Handle closing third-level panels
// document.body.addEventListener('click', function (event) {
//     if (event.target.classList.contains('third-level-back') || event.target.closest('.third-level-back')) {
//         document.querySelectorAll('.third-level[open]').forEach(thirdLevelPanel => {
//             thirdLevelPanel.removeAttribute('open');
//             Object.assign(thirdLevelPanel.style, {
//                 display: 'none',
//                 opacity: '0',
//                 transform: 'translateX(-100%)'
//             });
//         });

//         // Reset all second-menu buttons' aria-expanded attribute
//         document.querySelectorAll('.second-menu-btn').forEach(button => button.setAttribute('aria-expanded', 'false'));

//         // Hide the associated header-sidebar__sub-panel
//         let parentPanel = event.target.closest('.header-sidebar__sub-panel');
//         if (parentPanel) {
//             parentPanel.setAttribute('hidden', '');
//         }
//     }
// });


console.log("=== DEBUG SCRIPT LOADED ===");

var megaMenuItems = document.querySelectorAll(".header__primary-nav-item .header__menu-disclosure");
console.log("megaMenuItems => ", megaMenuItems);

if (megaMenuItems.length) {
  megaMenuItems.forEach((megaMenu) => {
    var closeMenuBtn = megaMenu.querySelector(".menu-close-btn");
    console.log("closeMenuBtn => ", closeMenuBtn);

    if (closeMenuBtn) {
      closeMenuBtn.addEventListener('click', function () {
        console.log("Mega menu close clicked...");
        megaMenu.setAttribute("aria-expanded", "false");
        megaMenu.removeAttribute('open');
      });
    }
  });
}

function showActiveSecondLevelPanel() {
  const activeButton = document.querySelector('.header-sidebar__main-panel li > button[aria-expanded="true"]');
  console.log("Active second level button => ", activeButton);

  if (!activeButton) return;

  const panelId = activeButton.getAttribute('aria-controls');
  console.log("panelId => ", panelId);

  const secondLevelPanel = document.querySelector('.header-sidebar__collapsible-panel.second-level');
  console.log("secondLevelPanel => ", secondLevelPanel);

  const targetPanel = secondLevelPanel?.querySelector(`#${panelId}`);
  console.log("targetPanel => ", targetPanel);

  if (targetPanel) {
    console.log("Removing hidden from target panel...");
    targetPanel.removeAttribute('hidden');
  } else {
    console.log("⚠ targetPanel NOT FOUND!");
  }

  
}


document.querySelectorAll('.second-menu-btn').forEach(button => {
  console.log("Found second menu button => ", button);

  button.addEventListener('click', function () {

    console.log("SECOND LEVEL BTN CLICKED ====");
    console.log("Clicked button => ", this);

    // Close all other panels
    document.querySelectorAll('.second-menu-btn').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });

    // Now open clicked one
    this.setAttribute('aria-expanded', 'true');

    let targetId = this.getAttribute('aria-controls');
    console.log("targetId => ", targetId);

    let parentPanel = this.closest('.header-sidebar__sub-panel');
    console.log("parentPanel => ", parentPanel);

    if (!parentPanel) {
      console.log("⚠ parentPanel NOT FOUND!");
      return;
    }

    let nextDiv = parentPanel.nextElementSibling;
    console.log("nextDiv => ", nextDiv);

    if (!nextDiv) {
      console.log("⚠ nextDiv NOT FOUND!");
      return;
    }

    console.log("Setting OPEN on nextDiv");
    nextDiv.setAttribute('open', '');

    Object.assign(nextDiv.style, {
      display: 'block',
      opacity: '1',
      transform: 'translateX(0px)'
    });

    let targetDiv = nextDiv.querySelector(`#${targetId}`);
    console.log("targetDiv (third level) => ", targetDiv);

    if (targetDiv) {
      console.log("Removing hidden of third level...");
      targetDiv.removeAttribute('hidden');
    } else {
      console.log("⚠ targetDiv NOT FOUND inside third-level panel!");
    }
  });
});


// Third level close button
document.body.addEventListener('click', function (event) {

  let isBack = event.target.classList.contains('third-level-back') ||
               event.target.closest('.third-level-back');

  if (isBack) {
    console.log("THIRD LEVEL BACK CLICKED");

    document.querySelectorAll('.third-level[open]').forEach(thirdLevelPanel => {
      console.log("Closing third level panel => ", thirdLevelPanel);

      thirdLevelPanel.removeAttribute('open');
      Object.assign(thirdLevelPanel.style, {
        display: 'none',
        opacity: '0',
        transform: 'translateX(-100%)'
      });
    });

    document.querySelectorAll('.second-menu-btn').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });

    let parentPanel = event.target.closest('.header-sidebar__sub-panel');
    console.log("third-level parentPanel => ", parentPanel);

    if (parentPanel) {
      console.log("Hiding parent sub-panel");
      parentPanel.setAttribute('hidden', '');
    }
  }
});



// Product page Recommendation section
// var productCards = document.querySelectorAll(".recommendations-section .product-card");
// console.log("productCards",productCards);
// if(productCards.length){
//   productCards.forEach((productCard)=>{
//     console.log("product Card",productCard);
//   });
// }

//Collection apge product cards size options
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(()=> {
    var productCards = document.querySelectorAll(".shopify-section--featured-collections .product-card");
  console.log("productCards 222>>> ",productCards);
  if (productCards.length) {
    productCards.forEach((productCard) => {
      var sizeElem = productCard.querySelector(".size_options_wrapper .sizes");
  
      if (sizeElem) {
        var sizeLabels = sizeElem.querySelectorAll(".size-label");
  console.log("sizeLabels >>> ",sizeLabels);
        if (sizeLabels.length) {
          sizeLabels.forEach((sizeLabel) => {
            sizeLabel.addEventListener("click", function () {
              var variantId = sizeLabel.getAttribute("data-variant");
              var productUrl = productCard.querySelector(".size_options_wrapper").getAttribute("data-url"); // Fixed selector
  
              if (variantId && productUrl) {
                var updatedUrl = new URL(productUrl, window.location.origin);
                updatedUrl.searchParams.set("variant", variantId);
                window.location.href = updatedUrl.toString();
              }
            });
          });
        }
      }
  
  
      var quicksizeElem = productCard.querySelector(".related_variant-picker .size");
      if (quicksizeElem) {
        quicksizeElem.addEventListener('click', function () {
          productCards.forEach((card) => {
            if (card !== productCard) {
              let otherSizeElem = card.querySelector(".related_variant-picker .size");
              if (otherSizeElem) {
                otherSizeElem.classList.remove('active');
              }
            }
          });
          quicksizeElem.classList.toggle('active');
        });
      }
  
      var sizeTypes = productCard.querySelectorAll(".related_variant-picker .size-label-add");
      if(sizeTypes.length){
        sizeTypes.forEach((sizeType)=>{
          sizeType.addEventListener('click',function(){
            var selected_value = sizeType.getAttribute("data-value");
            // console.log("selected value",selected_value);
            productCard.querySelector(".sizes-wrapper .selected_value").textContent = selected_value;
  
            var variantId = sizeType.getAttribute("data-variant");
            var originalPrice = sizeType.getAttribute("data-original-price");
            console.log(originalPrice);
            console.log("productCard.querySelector(input[name=id]) >>> ",productCard);
            productCard.querySelector("input[name='id']").value = variantId;
            productCard.querySelector("input[name='properties[_Originalprice]']").value = originalPrice;
          });
        });
      }
    });
  }
  },1000);
  
});


document.addEventListener("DOMContentLoaded", function () {
  setTimeout(()=> {
    var productCards = document.querySelectorAll(".look-product-wrapper .product-card");
  console.log("productCards 222>>> ",productCards);
  if (productCards.length) {
    productCards.forEach((productCard) => {
      var sizeElem = productCard.querySelector(".size_options_wrapper .sizes");
  
      if (sizeElem) {
        var sizeLabels = sizeElem.querySelectorAll(".size-label");
  console.log("sizeLabels >>> ",sizeLabels);
        if (sizeLabels.length) {
          sizeLabels.forEach((sizeLabel) => {
            sizeLabel.addEventListener("click", function () {
              var variantId = sizeLabel.getAttribute("data-variant");
              var productUrl = productCard.querySelector(".size_options_wrapper").getAttribute("data-url"); // Fixed selector
  
              if (variantId && productUrl) {
                var updatedUrl = new URL(productUrl, window.location.origin);
                updatedUrl.searchParams.set("variant", variantId);
                window.location.href = updatedUrl.toString();
              }
            });
          });
        }
      }
  
  
      var quicksizeElem = productCard.querySelector(".related_variant-picker .size");
      if (quicksizeElem) {
        quicksizeElem.addEventListener('click', function () {
          productCards.forEach((card) => {
            if (card !== productCard) {
              let otherSizeElem = card.querySelector(".related_variant-picker .size");
              if (otherSizeElem) {
                otherSizeElem.classList.remove('active');
              }
            }
          });
          quicksizeElem.classList.toggle('active');
        });
      }
  
      var sizeTypes = productCard.querySelectorAll(".related_variant-picker .size-label-add");
      if(sizeTypes.length){
        sizeTypes.forEach((sizeType)=>{
          sizeType.addEventListener('click',function(){
            var selected_value = sizeType.getAttribute("data-value");
            // console.log("selected value",selected_value);
            productCard.querySelector(".sizes-wrapper .selected_value").textContent = selected_value;
  
            var variantId = sizeType.getAttribute("data-variant");
            var originalPrice = sizeType.getAttribute("data-original-price");
            console.log(originalPrice);
            console.log("productCard.querySelector(input[name=id]) >>> ",productCard);
            productCard.querySelector("input[name='id']").value = variantId;
            productCard.querySelector("input[name='properties[_Originalprice]']").value = originalPrice;
          });
        });
      }
    });
  }
  },1000);
  
});


document.addEventListener("DOMContentLoaded", function () {
    var wrapper = document.querySelector(".richtext-wrapper");
    var content = document.querySelector(".dd-collection .shopify-section--rich-text-custom .metafield-rich_text_field");
    var button = document.querySelector(".read-more-btn");

    if (content?.scrollHeight > 577) {
        wrapper.classList.add("has-overflow");
    }

    button?.addEventListener("click", function () {
        wrapper.classList.toggle("expanded");
        button.textContent = wrapper.classList.contains("expanded") ? "Read less..." : "Read more...";
    });
});

  document.addEventListener("DOMContentLoaded", function () {
    const hash = window.location.hash;

    if (hash) {
      const target = document.querySelector(hash);

      if (target) {
        // Find the <details> element inside the accordion
        const details = target.querySelector(".accordion__wrapper details");

        if (details && !details.open) {
          details.open = true;
          details.setAttribute("aria-expanded", "true");
        }

        // Delay the scroll to ensure layout/rendering is ready
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300);
      }
    }
  });


/////////////////////// size page js /////////////////////////////
                  $ = jQuery;
                  $('.tab-menu.nb').click(function (e) { 
                      e.preventDefault();
                      $('.tab-menu.nb').removeClass('active');
                  
                      if ( !$(this).is( ".active" ) ) {
                          $(this).addClass('active');
                      }
                  
                      var $idt = $(this).attr('id');
                      $("#lp_guide_taille #tab-1 .sub-tab").removeClass('active');
                      $('[data-id="'+$idt+'"]').addClass('active'); 
                  });
                  
                  $('.tab-menu.ef').click(function (e) { 
                      e.preventDefault();
                      $('.tab-menu.ef').removeClass('active');
                  
                      if ( !$(this).is( ".active" ) ) {
                          $(this).addClass('active');
                      }
                  
                      var $idt = $(this).attr('id');
                      $("#lp_guide_taille #tab-2 .sub-tab").removeClass('active');
                      $('[data-id="'+$idt+'"]').addClass('active');
                  });
                  
                  $('.tab-menu.eg').click(function (e) { 
                      e.preventDefault();
                      $('.tab-menu.eg').removeClass('active');
                      
                      if ( !$(this).is( ".active" ) ) {
                          $(this).addClass('active');
                      }
                  
                      var $idt = $(this).attr('id');
                      $("#lp_guide_taille #tab-3 .sub-tab").removeClass('active');
                      $('[data-id="'+$idt+'"]').addClass('active');
                  });
                  
                  $("#nav-principale ul li a").click(function (e) { 
                      e.preventDefault();
                      $('#nav-principale ul li').removeClass('active');
                      $(this).parent('#nav-principale ul li').addClass('active');
                      var $href =$(this).attr('href');
                      $('#lp_guide_taille .tab').removeClass('active');
                      $('#lp_guide_taille #'+$href).addClass('active');
                      //#lp_guide_taille #tab
                  });
                  // document.querySelector('.collap').addEventListener('click', function() {
                  //     var $idp=$(this).attr('id');
                  //     document.querySelector('.par.'+$idp+'.collapsible').classList.toggle('collapsed');
                  //      $(this).parents('.s-cnt').toggleClass('colap-h');
                  
                  // });
                  
                  $('.collap').click(function (e) { 
                      e.preventDefault();
                      var $idp=$(this).attr('id');
                      if ( !$('.par.'+$idp+'.collapsible').is( ".collapsed" ) ) {
                          $(this).find('img').attr('src','https://www.jacadi.co.uk/medias/Plus.svg?context=bWFzdGVyfHJvb3R8MTE3NHxpbWFnZS9zdmcreG1sfGg1YS9oZjYvOTI2NTQyMTQ4NDA2Mi9QbHVzLnN2Z3xlMTU5YzE3Y2U1MjVlNTk4NGNlNWQ1MDlmYjY1ZDExYjVmMWUyYWY4ZDIyMjNiOTEzNDU1ZTQyMjlmYmNjZjQy');
                      }
                      else
                      {
                          $(this).find('img').attr('src','https://www.jacadi.co.uk/medias/Moins.svg?context=bWFzdGVyfHJvb3R8MTExMnxpbWFnZS9zdmcreG1sfGgwYi9oZTgvOTI2NTQyMTAyNTMxMC9Nb2lucy5zdmd8NzVjNzIwNmUzOWZhNjAyMzNmZjI2YzQxMWJmMmI0YmE4Yjk2ODNlNWY4NDBkNmNiZWY4YjNlY2RjNTA1ZWI5Nw');
                      }
                      $('.par.'+$idp+'.collapsible').toggleClass('collapsed');
                      $(this).parents('.s-cnt').toggleClass('colap-h'); 
                  });
                  
                  $(document).ready(function () {
                      span();
                  });
                  
                  $(window).on('resize', function(){
                      span();
                  });
                  
                  
                

                  
                  function span(){
                      if(window.matchMedia("(max-width: 767px)").matches){
                        $('#lp_guide_taille .visual-m .visual-d').each(function() {
                              var $text = $(this).attr('data-spn');
                              $(this).find('.d-d').text($text);
                          });
                      } 
                  }
                      // if ( $(this).is( ".active" ) ) {
                      //     $img= $img.replace('-active','');
                      //     $src = $img;
                      //     $(this).removeClass('active');
                      // }

////////////////////////////////////////////////////////////////////////////////

// add selected size variant product to cart shop-the-look-section start

document.addEventListener("DOMContentLoaded", function () {
  
  // Show/hide size options based on checkbox state
  document.querySelectorAll(".look-product-checkbox").forEach(function (checkbox) {
    checkbox.addEventListener("change", function () {
      const productId = this.dataset.productId;
      const productCard = document.querySelector(`.look-product-wrapper[data-product-id="${productId}"]`);

      if (productCard) {
        const sizeWrapper = productCard.querySelector(".related_variant-picker .size");

        if (this.checked) {
          sizeWrapper?.classList.add("active");
        } else {
          sizeWrapper?.classList.remove("active");
          productCard.querySelectorAll('.size-label-add.selected').forEach(el => el.classList.remove('selected'));
        }
      }
    });
  });

  // Handle size selection within each card
  document.querySelectorAll('.size-label-add').forEach(label => {
    label.addEventListener('click', function () {
      const productCard = label.closest('.cst-pdp-card');
      
      if (productCard) {
        const wrapper = productCard.closest('.look-product-wrapper');
        const checkbox = wrapper?.querySelector('.look-product-checkbox');
        const selectedValue = productCard.querySelector('.sizes-wrapper .selected_value');

        if (label.classList.contains('open-size-chart')) {
          setTimeout(() => {
            if (selectedValue) {
              selectedValue.textContent = 'Select a size';
            }   
          }, 100); 
          return;
        }

        productCard.querySelectorAll('.size-label-add').forEach(l => l.classList.remove('selected'));
        label.classList.add('selected');

        if (checkbox && !checkbox.checked) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change'));
        }

        const sizeWrapper = productCard.querySelector(".related_variant-picker .size");
        sizeWrapper?.classList.add("active");
      }
    });
  });

  // Handle Add to Bag button click
  const btn_add_to_cart = document.getElementById('add-to-bag-button');

  if (btn_add_to_cart) {
    btn_add_to_cart.addEventListener('click', function () {
      const itemsToAdd = []; // Reset every click

      document.querySelectorAll('.cst-pdp-card').forEach(function (productCard) {
        const wrapper = productCard.closest('.look-product-wrapper');
        const checkbox = wrapper?.querySelector('.look-product-checkbox');

        if (checkbox?.checked) {
          const selectedSizeElement = productCard.querySelector('.size-label-add.selected');

          if (selectedSizeElement && selectedSizeElement.dataset.variant) {
            // Multiple variant product with size selected
            itemsToAdd.push({
              id: parseInt(selectedSizeElement.dataset.variant),
              quantity: 1,
              properties: {
                "_Originalprice": selectedSizeElement.dataset.originalPrice
              }
            });
          } else {
            // Fallback for single-variant products
            const hiddenVariantInput = productCard.querySelector('input[name="id"]');
            if (hiddenVariantInput && hiddenVariantInput.value) {
              itemsToAdd.push({
                id: parseInt(hiddenVariantInput.value),
                quantity: 1
              });
            } else {
              // No size selected for multi-variant product → uncheck
              checkbox.checked = false;
            }
          }
        }
      });

      if (itemsToAdd.length > 0) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd }),
        })
        .then(res => res.json())
        .then(data => {
          console.log('Items added to cart:', data);
          this.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          const clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
          document.getElementById('open-cart-drawer').dispatchEvent(clickEvent);
        })
        .catch(err => {
          console.error('Error adding items:', err);
          alert('There was a problem adding items to your cart.');
        });
      } else {
        alert('Please select a size for at least one checked product.');
      }
    });
  }
});


// add selected size variant product to cart shop-the-look-section end

document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.querySelector(".add-to-cart-btn");
  const checkboxes = document.querySelectorAll(".checkbox");
  const variantInput = document.querySelector('input[name="id"]'); // Shopify's hidden variant input
  const sizeOptions = document.querySelectorAll(".size-option");

  function validateSelections() {
    const isAnyCheckboxChecked = Array.from(checkboxes).some(cb => cb.checked);
    const isVariantSelected = variantInput && variantInput.value.trim() !== ""; // Check if variant is actually selected
    
    if (isAnyCheckboxChecked && isVariantSelected) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove("disabled");
    } else {
      if(addToCartBtn){
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add("disabled");
      }
    }
  }

  // Checkbox change event
  checkboxes.forEach(cb => {
    cb.addEventListener("change", validateSelections);
  });

  // Size option click (if custom size UI)
  sizeOptions.forEach(opt => {
    opt.addEventListener("click", function () {
      sizeOptions.forEach(o => o.classList.remove("selected"));
      this.classList.add("selected");
      validateSelections();
    });
  });

  // Variant change (Shopify's select or swatch)
  document.addEventListener("change", function (e) {
    if (e.target.name === "id") {
      validateSelections();
    }
  });

  // Initial check on page load
  validateSelections();
});


/* show price total to the top shop the look product page start */
document.addEventListener('DOMContentLoaded', function () {
  // Calculate total of all listed products
  let total = 0;
  const checkboxes = document.querySelectorAll('.look-product-checkbox');

  checkboxes.forEach(cb => {
    const priceValue = parseFloat(cb.getAttribute('data-price'));
    if (!isNaN(priceValue)) {
      total += priceValue;
    }
  });

  const totalInPaise = Math.round(total * 100);
  const formattedTotal = Shopify.formatMoney(totalInPaise, Shopify.money_format);

  const totalDisplay = document.querySelector('.custom-price-show');
  if (totalDisplay) {
    totalDisplay.textContent = (`From ${formattedTotal}`);
  }

  // Update selected count and selected total
  function updateSelectedCount() {
    const selectedCheckboxes = document.querySelectorAll('.look-product-checkbox:checked');
    const selectedCount = selectedCheckboxes.length;

    const countDisplay = document.querySelector('.jac-look-item-selected-count');
    if (countDisplay) {
      countDisplay.textContent = selectedCount;
    }

    let selectedTotal = 0;
    selectedCheckboxes.forEach(cb => {
      const price = parseFloat(cb.getAttribute('data-price'));
      if (!isNaN(price)) {
        selectedTotal += price;
      }
    });

    const selectedTotalInPaise = Math.round(selectedTotal * 100);
    const formattedSelectedTotal = Shopify.formatMoney(selectedTotalInPaise, Shopify.money_format);

    const totalAmountDisplay = document.querySelector('.jac-look-item-total strong.jac-look-item-total');
    if (totalAmountDisplay) {
      totalAmountDisplay.textContent = formattedSelectedTotal;
    }
  }

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateSelectedCount);
  });

  updateSelectedCount(); // initial display
});
/* show price total shop the look product page end */



//   const giftWrapVariantId = 41756102131775;

// // Check if gift wrap is present in cart
// async function isGiftWrapInCart() {
//   try {
//     const res = await fetch('/cart.js');
//     const cart = await res.json();
//     return cart.items.some(item => item.variant_id === giftWrapVariantId);
//   } catch {
//     return false;
//   }
// }

// // Update gift wrap checkbox and message visibility
// function updateGiftWrapUI(isChecked) {
//   document.querySelectorAll('.free-gift-wrapping-main').forEach(wrapper => {
//     const checkbox = wrapper.querySelector('.free-gift-wrapping-switch');
//     const messageBox = wrapper.querySelector('.free-gift-wrapping-Write-message-main');
//     if (!checkbox || !messageBox) return;
//     checkbox.checked = isChecked;
//     messageBox.style.display = isChecked ? 'block' : 'none';
//   });
// }

// // Add gift wrap to cart
// async function addGiftWrap() {
//   await fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ id: giftWrapVariantId, quantity: 1 })
//   });
//   document.dispatchEvent(new CustomEvent('cart:refresh'));
// }

// // Remove gift wrap from cart
// async function removeGiftWrap() {
//   try {
//     const res = await fetch('/cart.js');
//     const cart = await res.json();
//     const item = cart.items.find(i => i.variant_id === giftWrapVariantId);
//     if (item) {
//       const idToRemove = item.key || item.id;
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: idToRemove, quantity: 0 })
//       });
//       document.dispatchEvent(new CustomEvent('cart:refresh'));
//     }
//   } catch (e) {
//     console.error('Error removing gift wrap:', e);
//   }
// }

// // Handle checkbox interaction
// function onGiftWrapToggle(e) {
//   const isChecked = e.target.checked;
//   updateGiftWrapUI(isChecked);

//   if (window.location.pathname === '/cart') {
//     if (isChecked) {
//       addGiftWrap().then(() => window.location.reload());
//     } else {
//       removeGiftWrap().then(() => window.location.reload());
//     }
//   } else {
//     if (isChecked) {
//       addGiftWrap();
//     } else {
//       removeGiftWrap();
//     }
//   }
// }

// // Re-attach listener after DOM is refreshed
// function setupGiftWrapListeners() {
//   document.querySelectorAll('.free-gift-wrapping-switch').forEach(checkbox => {
//     checkbox.removeEventListener('change', onGiftWrapToggle);
//     checkbox.addEventListener('change', onGiftWrapToggle);
//   });
// }

// // Sync checkbox UI and listeners with cart data
// async function syncGiftWrapUIAndListeners() {
//   const isChecked = await isGiftWrapInCart();
//   updateGiftWrapUI(isChecked);
//   setupGiftWrapListeners();
// }

// // Initial load
// document.addEventListener('DOMContentLoaded', () => {
//   syncGiftWrapUIAndListeners();
// });

// // On cart update (drawer refresh)
// document.addEventListener('cart:refresh', () => {
//   setTimeout(syncGiftWrapUIAndListeners, 0);
// });

  
   const messageTextarea = document.getElementById('giftMessage');

  if (messageTextarea) {
    messageTextarea.addEventListener('change', async () => {
      const note = messageTextarea.value.trim();
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note })
        });
        console.log('Gift message saved to cart note.');
      } catch (e) {
        console.error('Failed to update cart note:', e);
      }
    });
  }



  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.free-gift-wrapping-Write-message-inner').forEach(wrapper => {
      const textarea = wrapper.querySelector('textarea');
      const counter = wrapper.querySelector('.free-gift-wrapping-Write-message-limit');
      const maxLength = parseInt(textarea?.getAttribute('maxlength') || 135);

      if (textarea && counter) {
        const updateCount = () => {
          const remaining = maxLength - textarea.value.length;
          counter.textContent = `${remaining} characters remaining`;
        };

        textarea.addEventListener('input', updateCount);
        updateCount(); // initialize
      }
    });
  });


document.querySelectorAll('.jac-mt-12-js-scroll-to').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const target = document.querySelector(targetId);
    const offsetElem = document.querySelector(this.dataset.scrolltoOffsetElem);
    const baseOffset = offsetElem ? offsetElem.offsetHeight : 0;
    const extraOffset = parseInt(this.dataset.scrolltoOffset) || 0;
    const totalOffset = baseOffset + extraOffset;

    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - totalOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  });
});




document.querySelector('.mesure')?.addEventListener('click', function () {
  // Step 1: Find active tab
  const activeTab = document.querySelector('.tab.active');
  if (!activeTab) return;

  // Step 2: Inside active tab, find active sub-tab
  const activeSubTab = activeTab.querySelector('.sub-tab.active');
  if (!activeSubTab) return;

  // Step 3: Inside active sub-tab, find .mesur-cnt
  const mesurCnt = activeSubTab.querySelector('.mesur-cnt');
  if (mesurCnt) {
    mesurCnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});





window.addEventListener('load', function () {
  const sizeFieldsets = document.querySelectorAll('fieldset.variant-picker__option');

  sizeFieldsets.forEach(fieldset => {
    const legend = fieldset.querySelector('legend');
    if (legend && legend.textContent.trim().toLowerCase() === 'size:') {
      const sizeRadios = fieldset.querySelectorAll('input[type="radio"]');
      sizeRadios.forEach(radio => {
        radio.checked = false;
        radio.removeAttribute('checked');
      });

      // Also clear hidden selected variant input if needed
      const form = fieldset.closest('form');
      if (form) {
        const hiddenInput = form.querySelector('input[name="id"]');
        if (hiddenInput) hiddenInput.value = '';
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  console.log("11220");
  const customBtn = document.querySelector("#custom-add-btn");
  console.log("customBtn",customBtn);

  customBtn?.addEventListener("click", function () {
    const body = document.body;
    const isGiftProduct = body.classList.contains("gift-product");

    if (isGiftProduct) {
      // Gift product page
      alert("Gift cards cannot be purchased with other items. Please purchase separately.");
    } else {
      // Other product page
      alert("Please remove e-gift-card from cart before adding another product.");
    }
  });
});

const cart = await fetch("/cart.js").then((res) => res.json());

 const GIFT_CARD_PRODUCT_ID = "7841795670079";
  let giftFlag = 0;
  let otherFlag = 0;

  for (const item of cart.items) {
    if (item.product_id.toString() === GIFT_CARD_PRODUCT_ID && item.quantity > 0) {
      giftFlag = 1;
    } else if (item.quantity > 0) {
      otherFlag = 1;
    }
  }
  
  // ✅ After your giftFlag/otherFlag logic
console.log(giftFlag, 'giftFlag');
console.log(otherFlag, 'otherFlag');

const buyButtons = document.querySelector("buy-buttons");
const themeBtn = buyButtons?.querySelector("#theme-add-btn");
const customBtn = buyButtons?.querySelector("#custom-add-btn");
const giftProductSection = document.querySelector("body.gift-product");
const stickybutton = document.querySelector(".product-sticky-bar button");

console.log("stickybutton",stickybutton);
// Reset button visibility


themeBtn?.classList.remove("hidden");
customBtn?.classList.add("hidden");

// ✅ 1. Case: Both giftFlag = 0 & otherFlag = 0 → Show only theme button
if (giftFlag === 0 && otherFlag === 0) {
  themeBtn?.classList.remove("hidden");
  customBtn?.classList.add("hidden");
  stickybutton?.removeAttribute('disabled');
}

// ✅ 2. Case: giftFlag = 0 & otherFlag = 1 → Show custom button only if `.gift-product` exists
else if (giftFlag === 0 && otherFlag === 1) {
  if (giftProductSection) {
    customBtn?.classList.remove("hidden");
    themeBtn?.classList.add("hidden");
    stickybutton.setAttribute("disabled","");
  } else {
    customBtn?.classList.add("hidden");
    themeBtn?.classList.remove("hidden");
    stickybutton?.removeAttribute('disabled');
  }
}

// ✅ 3. Case: giftFlag = 1 & otherFlag = 0 → Show theme button only if `.gift-product` exists
else if (giftFlag === 1 && otherFlag === 0) {
  if (giftProductSection) {
    customBtn?.classList.add("hidden");
    themeBtn?.classList.remove("hidden");
    stickybutton?.removeAttribute('disabled');
  } else {
    customBtn?.classList.remove("hidden");
    themeBtn?.classList.add("hidden");
    stickybutton?.setAttribute("disabled","");
  }
}

// ✅ 4. Case: giftFlag = 1 & otherFlag = 1 → Always show only custom button
else if (giftFlag === 1 && otherFlag === 1) {
  customBtn?.classList.remove("hidden");
  themeBtn?.classList.add("hidden");
  stickybutton?.setAttribute("disabled","");
}



// gazala code
// document.addEventListener("DOMContentLoaded", function () {
  
//   // Show/hide size options based on checkbox state
//   document.querySelectorAll(".look-product-checkbox").forEach(function (checkbox) {
//     checkbox.addEventListener("change", function () {
//       const productId = this.dataset.productId;
//       const productCard = document.querySelector(`.look-product-wrapper[data-product-id="${productId}"]`);

//       if (productCard) {
//         const sizeWrapper = productCard.querySelector(".related_variant-picker .size");

//         if (this.checked) {
//           sizeWrapper?.classList.add("active");
//         } else {
//           sizeWrapper?.classList.remove("active");
//           productCard.querySelectorAll('.size-label-add.selected').forEach(el => el.classList.remove('selected'));
//         }
//       }
//     });
//   });

//   // Handle size selection within each card
//   document.querySelectorAll('.size-label-add').forEach(label => {
//     label.addEventListener('click', function () {
     
//       const productCard = label.closest('.cst-pdp-card');
      
//       if (productCard){
//          console.log("111");
//         const wrapper = productCard.closest('.look-product-wrapper');
//         const checkbox = wrapper?.querySelector('.look-product-checkbox');
//         const selectedValue = productCard.querySelector('.sizes-wrapper .selected_value');

//         if (label.classList.contains('open-size-chart')) {
//           setTimeout(() => {
//           if (selectedValue) {
//             selectedValue.textContent = 'Select a size'; // or 'Size chart' if you prefer
//           }   
//          }, 100); 
//           return;
//         }
//         productCard.querySelectorAll('.size-label-add').forEach(l => l.classList.remove('selected'));
//         label.classList.add('selected');
  
//         if (checkbox && !checkbox.checked) {
//           checkbox.checked = true;
//           checkbox.dispatchEvent(new Event('change'));
//         }
//         const sizeWrapper = productCard.querySelector(".related_variant-picker .size");
//         console.log("sizeWrapper >> ",sizeWrapper);
//         sizeWrapper?.classList.add("active");
//       }
//     });
//   });

//   // Handle Add to Bag button click
//   const btn_add_to_cart = document.getElementById('add-to-bag-button');
//     const itemsToAdd = [];

//     if (btn_add_to_cart){
//       btn_add_to_cart.addEventListener('click', function () {
//       document.querySelectorAll('.cst-pdp-card').forEach(function (productCard) {
//         const wrapper = productCard.closest('.look-product-wrapper');
//         const checkbox = wrapper?.querySelector('.look-product-checkbox');
  
//         // if (checkbox?.checked) {
//         //   const selectedSizeElement = productCard.querySelector('.size-label-add.selected');
  
//         //   if (selectedSizeElement) {
//         //     const variantId = selectedSizeElement.dataset.variant;
//         //     itemsToAdd.push({
//         //       id: parseInt(variantId),
//         //       quantity: 1
//         //     });
//         //   }
//         //   else {
//         //     // Uncheck the checkbox and mark the flag
//         //     checkbox.checked = false;
//         //   }
//         // }
//        const selectedSizeElement = productCard.querySelector('.size-label-add.selected');

//         if (selectedSizeElement && selectedSizeElement.dataset.variant) {
//           const variantId = selectedSizeElement.dataset.variant;
//           itemsToAdd.push({
//             id: parseInt(variantId),
//             quantity: 1
//           });
//         } else {
//           // Fallback for single-variant products
//           const hiddenVariantInput = productCard.querySelector('input[name="id"]');
//           if (hiddenVariantInput && hiddenVariantInput.value) {
//             itemsToAdd.push({
//               id: parseInt(hiddenVariantInput.value),
//               quantity: 1
//             });
//           } else {
//             checkbox.checked = false; // Uncheck if no variant found
//           }
//         }


        
//       });
  
//       if (itemsToAdd.length > 0) {
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ items: itemsToAdd }),
//         })
//         .then(res => res.json())
//         .then(data => {
//           console.log('Items added to cart:', data);
//           this.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
//           var clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
//           document.getElementById('open-cart-drawer').dispatchEvent(clickEvent);
//         })
//         .catch(err => {
//           console.error('Error adding items:', err);
//           alert('There was a problem adding items to your cart.');
//         });
//       } else {
//         alert('Please select a size for at least one checked product.');
//       }
//     });
//   }
// });
